import { StyleSheet } from '@react-pdf/renderer';

export default StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        fontFamily: 'Regular',
        fontSize: 10,
        padding: 20,
        paddingBottom: 60,
    },
    top: {
        flexDirection: 'row',
        marginBottom: 30,
    },
    title: {
        fontSize: 15,
        fontFamily: 'Bold',
    },
    logo: {
        marginRight: 15,
        width: 60,
    },
    left: {
        flex: 1,
        justifyContent: 'space-between',
    },
    right: {
        width: '10%',
    },
    marginTop: {
        marginTop: 20,
    },
    marginLeft: {
        marginLeft: 20,
    },
});
